<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：学校资源库  >  <router-link to="/paper_video" class="cl_gray">视频库</router-link>  >  视频预览</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="video_play_cont">
					<div class="f18px">{{data.name}}</div>
					<div class="cl_gray mat10">上传人：{{data.add_user_name}}</div>
					<div class="mat30">
						<video-player  v-if="JSON.stringify(data) != '{}'" class="video-player vjs-custom-skin block" ref="videoPlayer" :playsinline="true"
						 :options="playerOptions"></video-player>
					</div>
					<div class="f18px cl_dark mat30">视频简介</div>
					<div class="cl_gray mat10">{{data.intro}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 0,
					listCur: 0,
					open: 0,
				},
				id: "",
				data: {},
				//播放设置
				playerOptions: {
					//播放速度
					playbackRates: [0.5, 1.0, 1.5, 2.0], 
					//如果true,浏览器准备好时开始回放。
					autoplay: false, 
					// 默认情况下将会消除任何音频。
					muted: false, 
					// 导致视频一结束就重新开始。
					loop: false, 
					// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					preload: 'auto', 
					language: 'zh-CN',
					 // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					aspectRatio: '16:9',
					 // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					fluid: true,
					sources: [
						{
							type: "video/mp4",
							src: "",
						},
					],
					//你的封面地址
					poster: '',
					//允许覆盖Video.js无法播放媒体源时显示的默认信息。
					notSupportedMessage: '此视频暂无法播放，请稍后再试',
					controlBar: {
							timeDivider: true,
							durationDisplay: true,
							remainingTimeDisplay: false,
							//全屏按钮
							fullscreenToggle: true  
					}
				},
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getDetails();
			}
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getDetails () {
				this.$get("/api/teacher/get_examination_video_show",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.data = res.data;
					this.playerOptions.sources[0].src = this.data.url;
				});
			},
		},
	}
</script>

<style>
</style>
